module.exports = __webpack_public_path__ + "img/two-pay-icon.27c20413.svg";